import no_data from 'assets/images/no_data.png'
import marker from "assets/images/marker.png";
import markerError from "assets/images/markerError.png";
import markerEvt from "assets/images/markerEvt.png";

const IMG_LIST = {
    NO_DATA : no_data,
    MARKER : {NORMAL : marker, ERROR : markerError, EVT : markerEvt},
};

export default IMG_LIST ;
export const {NO_DATA, MARKER} = IMG_LIST;
